import ReturnsTranslationsPage from './ReturnsTranslationsPage';
export default ReturnsTranslationsPage;
